// PlatformIcon — renders the correct logo for a given platform ID
import React from "react";
import { LOGO_MAP } from "./PlatformLogos";
import { getPlatformById } from "@/data/platforms";
import { useTheme } from "@/contexts/ThemeContext";
import { Cpu } from "lucide-react";

export default function PlatformIcon({ platformId, size = "md", variant, showName = false, className = "" }) {
  const { isDark } = useTheme();
  const platform = getPlatformById(platformId);
  const autoVariant = variant || (isDark ? "mono" : "color");

  if (!platform) {
    return (
      <span className={`inline-flex items-center gap-2 ${className}`}>
        <Cpu className="w-5 h-5 text-[var(--qn-foreground-muted)]" />
        {showName && <span className="text-sm">{platformId}</span>}
      </span>
    );
  }

  const LogoComponent = LOGO_MAP[platform.logoComponent];
  if (!LogoComponent) {
    return (
      <span className={`inline-flex items-center gap-2 ${className}`}>
        <span className="w-6 h-6 rounded bg-[var(--qn-surface)] flex items-center justify-center text-xs font-bold">
          {platform.name.charAt(0)}
        </span>
        {showName && <span className="text-sm">{platform.name}</span>}
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid={`platform-icon-${platformId}`}>
      <LogoComponent size={size} variant={autoVariant} />
      {showName && <span className="text-sm font-medium">{platform.name}</span>}
    </span>
  );
}

// Provider icon helper — maps provider key to a logo
const PROVIDER_PLATFORM_MAP = {
  openai: "chatgpt", anthropic: "claude", google: "gemini",
  meta: "meta_ai", xai: "grok", mistral: "mistral",
  deepseek: "deepseek", baidu: "baidu_ernie", alibaba: "qwen", cohere: "cohere",
};

export function ProviderIcon({ providerKey, size = "md", variant, showName = false, className = "" }) {
  const platformId = PROVIDER_PLATFORM_MAP[providerKey] || providerKey;
  return <PlatformIcon platformId={platformId} size={size} variant={variant} showName={showName} className={className} />;
}
